import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import './permission'
import Element from 'element-ui'

import "./assets/icon"
import './assets/icon/font_4381675_go75fp4bkkm/iconfont.css'  //icon
import './assets/icon/font_4381675_go75fp4bkkm/iconfont'  //icon

import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/styles/main.scss'
import '@/assets/styles/table.scss'
import '@/assets/styles/handle.scss'
import '@/assets/styles/transition.scss'
import '@/assets/styles/soft-phone.scss'

import Pagination from "@/components/Pagination";

import { resetForm,emptyVal,emptyTime } from "@/utils/form";

import {table1,table2,table3,table4,table5,table6,table7,table8} from "@/utils/layout"
import {handles} from "@/utils/tree"
import {parseTime,formatSeconds,formatTimestamp,data,dataYmd,timestamp,formatIsoToDateTime} from "@/utils/dateUtil"
import {Base64} from 'js-base64'  //base64加密
import {download} from "@/utils/request"  //通用下载方法
import directive from './directive' // 自定义指令
import plugins from './plugins' //方法
import Editor from "@/components/Editor"// 富文本组件
import orderLable from "@/components/orderLable"
Vue.prototype.resetForm = resetForm
Vue.prototype.emptyVal = emptyVal
Vue.prototype.emptyTime = emptyTime
Vue.prototype.table1 = table1
Vue.prototype.table2 = table2
Vue.prototype.table3 = table3
Vue.prototype.table4 = table4
Vue.prototype.table5 = table5
Vue.prototype.table6 = table6
Vue.prototype.table7 = table7
Vue.prototype.table8 = table8
Vue.prototype.handles = handles
Vue.prototype.parseTime = parseTime
Vue.prototype.formatSeconds = formatSeconds
Vue.prototype.formatTimestamp = formatTimestamp
Vue.prototype.timestamp = timestamp
Vue.prototype.formatIsoToDateTime = formatIsoToDateTime
Vue.prototype.data = data
Vue.prototype.dataYmd = dataYmd
Vue.prototype.download = download
Vue.prototype.$Base64 = Base64;


Vue.config.productionTip = false;
Vue.use(directive)
Vue.use(plugins)
Vue.use(Element)
Vue.component('Pagination', Pagination)
Vue.component('Editor', Editor)
Vue.component('orderLable', orderLable)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
